const createFeatureMutation = `
  mutation CreateMarketplaceFeature($fields: CreateMarketplace_featureFieldsInput) {
    createMarketplace_feature(input: { fields: $fields }) {
      marketplace_feature {
        objectId
        name
        label
        description
        plans { ... on Element { value } }
        createdAt
        updatedAt
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default createFeatureMutation;
